export default {
	isLeapYear: isLeapYear,
	diffInDays: diffInDays,
	lastOfMonth: lastOfMonth,
	addDays: addDays,
	plural: plural,
	textDays: textDays,
	textRubs: textRubs,
	textYears: textYears,
	textMonths: textMonths,
	textFloors: textFloors,
    wordEnding: wordEnding
}
export function wordEnding(value, array) {
    if (typeof value === 'string' || value instanceof String) {
        value = value.replace(/[^\d.-]/g, '');
    }
    value = Math.abs(value);
    if (Number.isInteger(value) && array.length === 3) {
        let options = [2, 0, 1, 1, 1, 2];
        return array[(value % 100 > 4 && value % 100 < 20) ? 2 : options[(value % 10 < 5) ? value % 10 : 5]];
    }
}

export function isLeapYear(year) {
	return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}
export function diffInDays(a, b) {
	var _MS_PER_DAY = 1000 * 60 * 60 * 24,
		utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate()),
		utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
	return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
}
export function lastOfMonth(date) {
	return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
export function addDays(date, days) {
	var endDate = new Date(date);
	endDate.setDate(endDate.getDate() + days);
	return endDate;
}

export function plural (words) {
	return function (num) {
		return words[1 === num % 10 && 11 !== num % 100 ? 0 : 2 <= num % 10 && 4 >= num % 10 && (10 > num % 100 || 20 <= num % 100) ? 1 : 2]
	}
}

export function textDays() {
	return plural(['день', 'дня', 'дней']);
}
export function textRubs() {
	return plural(['рубль', 'рубля', 'рублей']);
}
export function textYears() {
	return plural(['год', 'года', 'лет']);
}
export function textMonths() {
	return plural(['месяц', 'месяца', 'месяцев']);
}
export function textFloors() {
	return plural(['этаж', 'этажа', 'этажей']);
}
